import {gql, useMutation} from '@apollo/client';
import {ActiveTrend} from "../../types/nbaTypes";

const DELETE_TREND = gql`
    mutation DeleteTrend($trendId: String!) {
      deleteTrend(trendId: $trendId) {
        trend
        id
        trendDescription
      }
    }
`;

export const useDeleteTrend = () => {
    const [executeMutation, { data, loading, error }] = useMutation(DELETE_TREND);

    const deleteTrend = (trendId: string) => {
        return executeMutation({
            variables: { trendId },
            errorPolicy: 'all',
            refetchQueries: ['GetUserTrends'],
        });
    };

    return { deleteTrend, data, loading, error };
};

